/*jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

class DayPicker extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let constants = this.props.app.config.constants,
            days = [
                constants.FS_SUNDAY,
                constants.FS_MONDAY,
                constants.FS_TUESDAY,
                constants.FS_WEDNESDAY,
                constants.FS_THURSDAY,
                constants.FS_FRIDAY,
                constants.FS_SATURDAY
            ],
            dayNames = [
                'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'
            ],
            dayIcons = [],
            dayBlocks = [],
            onClick = (!this.props.controlActive) ? null : this.props.setDays,
            mainClass = (!this.props.controlActive) ? 'day-selectors disabled' : 'day-selectors';

        for (let i = 0; i < days.length; ++i) {
            if (days[i] & this.props.days) {
                dayIcons.push('icon ion-android-checkmark-circle');
                dayBlocks.push('day-block active');
            } else {
                dayIcons.push('icon ion-android-radio-button-off');
                dayBlocks.push('day-block');
            }
        }

        return (
            <div className={mainClass}>
                {dayBlocks.map((block, i) => {
                    return (
                        <div key={i} className={dayBlocks[i]} onClick={onClick} data-day={days[i]} role="button" aria-label="toggle day">
                            {this.props.labelPostion === 'top' ? (
                                <div className="day-name">
                                    {dayNames[i]}
                                </div>
                            ) : null}
                            <div className="day-selected">
                                <i className={dayIcons[i]}></i>
                            </div>
                            {this.props.labelPostion !== 'top' ? (
                                <div className="day-name">
                                    {dayNames[i]}
                                </div>
                            ) : null}
                        </div>
                    );
                })}
            </div>
        );


    }
}

DayPicker.propTypes = {
    setDays: PropTypes.func,
    days: PropTypes.number,
    controlActive: PropTypes.bool,
    labelPosition: PropTypes.string,
};

DayPicker.defaultProps = {
    setDays: () => {},
    days: 0x7f,
    controlActive: true,
    labelPosition: 'top'
};

export default DayPicker;
